import React, {useEffect, useRef} from 'react';

import './Layout.less';
import {PageScrollContext} from 'contexts/page-scroll-context.ts';

function animateScroll(targetScrollValue, layoutRef) {
	requestAnimationFrame(() => {
		if (targetScrollValue < 0) return;

		const scrollDelta = Math.abs(layoutRef.current.scrollTop - targetScrollValue);
		const AnimationStepSize = Math.min(Math.max(scrollDelta / 6, 8), scrollDelta);
		if (Math.abs(layoutRef.current.scrollTop - targetScrollValue) <= AnimationStepSize) {
			return;
		} else {
			layoutRef.current.scrollTop += Math.sign(targetScrollValue - layoutRef.current.scrollTop) * AnimationStepSize;
			animateScroll(targetScrollValue, layoutRef);
		}
	});
}

export const Layout = ({children}) => {
	const layoutRef = useRef(null);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="layout" ref={layoutRef}>
			<PageScrollContext.Provider
				value={{
					alignByElementBottom: elementBottom => {
						animateScroll(layoutRef.current.scrollTop - (layoutRef.current.clientHeight - elementBottom), layoutRef);
					},
				}}
			>
				{children}
			</PageScrollContext.Provider>
		</div>
	);
};
